import { createRoot } from "react-dom/client";
import { applyBrandToDocument } from "@/lib/applyBrandToDocument";
import "@/i18n";
import App from "./App.tsx";
import "./index.css";

applyBrandToDocument();

createRoot(document.getElementById("root")!).render(<App />);
